import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useConfirm } from 'material-ui-confirm';

import { ButtonBox } from '../molecules/button-box';
import { trpc } from '../api/trpc';

export const AuditLogDelete = () => {
  const confirm = useConfirm();

  const deleteAuditLog = trpc.auditLog.clear.useMutation();

  const handleClick = () => {
    confirm({
      title: (
        <FormattedMessage
          id="audit_log_delete.confirm.title"
          defaultMessage="Opravdu chcete smazat všechny záznamy v audit logu?"
        />
      ),
      confirmationText: (
        <FormattedMessage
          id="audit_log_delete.confirm"
          defaultMessage="Smazat"
        />
      ),
      cancellationText: (
        <FormattedMessage
          id="audit_log_delete.cancel"
          defaultMessage="Zrušit"
        />
      ),
    })
      .then(() => {
        return deleteAuditLog.mutateAsync();
      })
      .catch(() => {
        // noop
      });
  };

  return (
    <ButtonBox
      title={
        <FormattedMessage
          id="audit_log_delete.title"
          defaultMessage="Smazat audit log"
        />
      }
      buttonLabel={
        <FormattedMessage
          id="audit_log_delete.button"
          defaultMessage="Smazat"
        />
      }
      onClick={handleClick}
      fullWidth
    />
  );
};
